import { Box } from "@mui/system";
import HorizontalBarChartWithNegative from "../Charts/HorizontalBarChartWithNegative";
import classes from '../../Style/Findings.scss';
import csv from '../../Data/EUMACP/Overview/EU-MACP-Overview-of-samples-with-quantified-residues-above-MRL-and-non-compliant-Stacked-bar-chart.csv';

const Findings = (props) => {

    const fields = [
        "Below LOQ",
        "Between LOQ and MRL",
        "Above MRL",
    ];
    const colorMap = {
        "Below LOQ": "#00B289",
        "Between LOQ and MRL": "#9CDCCE",
        "Above MRL": "#FFCE3A",
        "Non-compliant": "#EF9800"
    };
    const retained = 'Food commodity';

    const findings = [
        {
            title: 'Total Number of samples',
            value: '12,077',
            sup: undefined,
            color: undefined,
        },
        {
            title: 'Below LOQ',
            value: '8,278',
            sup: '68.5%',
            color: '#00B289'
        },
        {
            title: 'Between LOQ & MRL',
            value: '3,590',
            sup: '29.7%',
            color: '#9CDCCE'
        },
        {
            title: 'Above MRL',
            value: '209',
            sup: '1.7%',
            color: '#FFCE3A'
        },
        {
            title: 'Non-compliant',
            value: '113',
            sup: '0.9%',
            color: '#EF9800'
        },
    ]
    return (
        <Box>
            <Box sx={{ marginBottom: '2rem', display: 'flex', flexWrap: 'wrap' }} className="findingsWrapper" justifyContent={{ xs: 'start', sm: 'start', md: 'space-between' }}>
                {
                    findings.map(f => {
                        const border = f.color ? `3px ${f.color} solid` : '';
                        return (
                            <Box key={f.title} className="finding" pl={1} sx={{ borderLeft: border }}>
                                <p>{f.title}</p>
                                <h3>
                                    {f.value}
                                    {f.sup && <sup>({f.sup})</sup>}
                                </h3>
                            </Box>
                        );
                    })
                }
            </Box>
            <Box sx={{ width: '100%' }}>
            </Box>
            <Box display='flex' flexDirection={{ xs: 'column', sm: 'column', md: 'row' }}>
                <Box flexGrow={3} order={{ xs: 2, sm: 2, md: 1 }}>
                    <HorizontalBarChartWithNegative title={'% of samples with quantified residues, above MRL and non-compliant'} small colorMap={colorMap} fields={fields} retained={retained} csv={csv} />
                </Box>
                <Box flexGrow={1} order={{ xs: 1, sm: 1, md: 2 }} sx={{ width: { xs: '100%', sm: '100%', md: '150px' } }}>
                    <HorizontalBarChartWithNegative title={'% of samples with quantified residues, above MRL and non-compliant'} chartImg={props.chartImg} small colorMap={colorMap} fields={['Non-compliant']} retained={retained} csv={csv} />
                </Box>
            </Box>
        </Box>

    );
}

export default Findings;